import { type ReactNode } from 'react';
import { css, type CSSProperties, type DefaultTheme, styled } from 'styled-components';

type RowProps = {
  space: keyof DefaultTheme['space']['component']['x'];
  justifyContent?: CSSProperties['justifyContent'];
  alignItems?: CSSProperties['alignItems'];
  reverse?: boolean;
  children: ReactNode;
  flexWrap?: CSSProperties['flexWrap'];
};

const rowStyles = css<RowProps>`
  flex-direction: row;
  && > * {
    margin-right: ${({ space, theme }) => theme.space.component.x[space]};
  }
  && > *:last-child {
    margin-right: 0;
  }
`;
const rowReverseStyles = css<RowProps>`
  flex-direction: row-reverse;
  /* stylelint-disable-next-line */
  && > * {
    margin-left: ${({ space, theme }) => theme.space.component.x[space]};
  }
  && > *:last-child {
    margin-left: 0;
  }
`;

export const Row = styled.div<RowProps>`
  display: flex;
  flex-wrap: ${({ flexWrap = 'wrap' }) => flexWrap};
  justify-content: ${({ justifyContent = 'flex-start' }) => justifyContent};
  align-items: ${({ alignItems = 'center' }) => alignItems};
  ${({ reverse }) => (reverse ? rowReverseStyles : rowStyles)};
`;
Row.displayName = 'Flex.Row';
